import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getAllPeopleAsync, getPersonByIdAsync, getAllPeopleForTasksAsync, getAllPeopleWithoutPaginationAsync, getReferredByPersonByMvpIdAsync, getAllPeopleRecentEvents } from './peopleThunk';
const initialState = {
    status: APIStatus.IDLE,
    allPeopleLoading: false
};
export const peopleSlice = createSlice({
    name: 'people',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllPeopleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.people = action.payload;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPersonByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPersonByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.person = action.payload;
            state.apiError = undefined;
        })
            .addCase(getPersonByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPeopleForTasksAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleForTasksAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.peopleForTasks = action.payload;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleForTasksAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPeopleWithoutPaginationAsync.pending, (state) => {
            state.allPeopleLoading = true;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleWithoutPaginationAsync.fulfilled, (state, action) => {
            state.allPeopleLoading = false;
            state.allPeople = action.payload;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleWithoutPaginationAsync.rejected, (state, action) => {
            state.allPeopleLoading = false;
            state.apiError = action.payload;
        });
        builder
            .addCase(getReferredByPersonByMvpIdAsync.pending, (state) => {
            state.referredByPersonLoading = true;
            state.referredByPerson = null;
        })
            .addCase(getReferredByPersonByMvpIdAsync.fulfilled, (state, action) => {
            state.referredByPersonLoading = false;
            state.referredByPerson = action.payload;
        })
            .addCase(getReferredByPersonByMvpIdAsync.rejected, (state) => {
            state.referredByPersonLoading = false;
            state.referredByPerson = null;
        });
        builder
            .addCase(getAllPeopleRecentEvents.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleRecentEvents.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.peopleRecentEvent = action.payload;
            state.apiError = undefined;
        })
            .addCase(getAllPeopleRecentEvents.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default peopleSlice.reducer;
